import { render, staticRenderFns } from "./ViewerHeaderNoImageTheme.vue?vue&type=template&id=c58b3124&scoped=true"
import script from "./ViewerHeaderNoImageTheme.vue?vue&type=script&lang=js"
export * from "./ViewerHeaderNoImageTheme.vue?vue&type=script&lang=js"
import style0 from "./ViewerHeaderNoImageTheme.vue?vue&type=style&index=0&id=c58b3124&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58b3124",
  null
  
)

export default component.exports